import { useEffect } from 'react';
import { trackPendoEvent } from 'src/helpers/trackPendoEvent';

export const useViewerModeTime = (
  mode: string,
  enabled: boolean,
  surface?: string,
  extra?: Record<string, string>
) => {
  const extraKey = JSON.stringify(extra ?? {});

  useEffect(() => {
    if (!enabled) return undefined;
    const extraProps = JSON.parse(extraKey) as Record<string, string>;
    let startedAt: number | null = document.visibilityState === 'hidden' ? null : Date.now();

    const flush = () => {
      if (startedAt === null) return;
      const seconds = Math.round((Date.now() - startedAt) / 1000);
      startedAt = null;
      if (seconds < 1) return;
      trackPendoEvent('viewer_mode_time', {
        mode,
        seconds,
        ...(surface && { surface }),
        ...extraProps
      });
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'hidden') flush();
      else if (startedAt === null) startedAt = Date.now();
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      flush();
    };
  }, [mode, enabled, surface, extraKey]);
};
